import React from "react";
import '../styles/pngtuber.css'

export default function PngTuber() {
    return (
        <section className="pngtubers">
            <h1 className="title-pngtubers">
                Galería de PNGtubers con expresiones únicas y personajes originales...
            </h1>
            <div className="png-container">
            <div className="png-frame">
                <img src="/dibujos/optimized/modelo_serio.png" alt="modelo-serio" loading="lazy"/>
            </div>
            <div className="png-frame">
                <img src="/dibujos/optimized/modelo_serio2.png" alt="modelo-serio2" loading="lazy"/>
            </div>
            <div className="png-frame">
                <img src="/dibujos/optimized/modelo_ojos_cerrados.png" alt="modelo-ojos_cerrados" loading="lazy"/>
            </div>
            <div className="png-frame">
                <img src="/dibujos/optimized/modelo_ojos_cerrados2.png" alt="modelo-ojos_cerrados2" loading="lazy"/>
            </div>
            </div>
        </section>
    );
}
